import { Trans, useTranslation } from 'react-i18next';
import { useState, type FC } from 'react';
import InformationIcon from 'components/atoms/icons/informationIcon';
import { Popover } from 'antd';
import { parseDateSafe } from 'utils/timeHelper';
import { convertDateToTimeZone, DateFormatter } from 'infrastructure/functions';
import { DateFormats } from 'infrastructure/enums';

import s from './styles.module.scss';

interface LatentReadingStatusProps {
  receivedTime: string;
  timezone: string;
}

const LatentReadingStatus: FC<LatentReadingStatusProps> = ({
  receivedTime,
  timezone,
}) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  const receivedDate = parseDateSafe(receivedTime);
  const receivedDateString = receivedDate
    ? DateFormatter({
        date: receivedDate,
        format: DateFormats['MM-dd-yyyy hh:mm:ss a'],
      })
    : '';
  const receivedDatePatientTime = receivedTime
    ? convertDateToTimeZone(new Date(parseInt(receivedTime)), timezone)
    : '';
  const receivedDateInPatientTimeString = DateFormatter({
    date: receivedDatePatientTime,
    format: DateFormats['MM-dd-yyyy hh:mm:ss a'],
  });

  const Content = () => (
    <div className={s['popover-content']}>
      <Trans
        i18nKey="messages.receivedReadingTimeMessage"
        values={{
          time: receivedDateString,
          patientTime: receivedDateInPatientTimeString,
        }}
        components={[<br />]}
      />
    </div>
  );

  return (
    <Popover
      content={Content}
      rootClassName={s['popover-wrapper']}
      placement="bottomRight"
      arrow={false}
      open={open}
      onOpenChange={setOpen}
    >
      <div
        className={s['latent-wrapper']}
        data-latent
        data-open={open}
        data-top-status
      >
        <p className={s['latent-text']}>{t('labels.latentReading')}</p>
        <InformationIcon width={13} height={13} className={s.icon} />
      </div>
    </Popover>
  );
};
export default LatentReadingStatus;
